<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
    styleClass="w-full sm:w-18rem">
    <div class="px-2">
        <h5>Profile</h5>
        <div class="timeline mb-4">
            <p>ข้อมูลผู้ใช้</p>
            <div class="pt-0 pr-3 surface-border ">
                <!-- <p-button icon="pi pi-user" [label]="fullName + '\n' + position" [outlined]="true" /> -->
                <button class="border-gray-300 border-round-xl w-full" pButton (click)="navToEditeProfile()" [outlined]="true">
                    <div class="flex gap-3">
                        <span class="align-self-center align-content-center bg-bluegray-500 border-round-xl w-3rem h-3rem text-white">
                            <i class="pi pi-user"></i>
                        </span>
                        <div class="flex flex-column align-content-start">
                            <div class="align-content-center text-left text-gray-700" style="text-wrap-mode: nowrap;">ชื่อ: {{ truncateText(fullName, 10) }}</div>
                            <div class="align-content-center text-left text-gray-700" style="text-wrap-mode: nowrap;">ตำแหน่ง: {{ truncateText(position, 10) }}</div>
                        </div>
                    </div>
                </button>
            </div>
        </div>
        <div class="timeline mb-5">
            <p>เมนูข้อมูลผู้ใช้</p>
            <div class="pt-0 pr-3 pb-3 surface-border relative">
                <button class="border-gray-300 border-round-xl w-full" pButton (click)="navToEditeProfile()" [outlined]="true">
                    <div class="flex gap-3">
                        <span class="align-content-center bg-blue-500 border-round-xl w-3rem h-3rem text-white">
                            <i class="pi pi-pencil"></i>
                        </span>
                        <div class="align-content-center text-gray-700">แก้ไขข้อมูลส่วนตัว</div>
                    </div>
                </button>
            </div>
            <div class="pt-0 pr-3 pb-3 surface-border relative">
                <button class="border-gray-300 border-round-xl w-full" pButton (click)="navToChangePass()" [outlined]="true">
                    <div class="flex gap-3">
                        <span class="align-content-center bg-yellow-500 border-round-xl w-3rem h-3rem text-white">
                            <i class="pi pi-unlock"></i>
                        </span>
                        <div class="align-content-center text-gray-700">แก้ไขรหัสผ่าน</div>
                    </div>
                </button>
            </div>
            <div class="pt-0 pr-3 pb-3 surface-border relative">
                <button class="border-gray-300 border-round-xl w-full" pButton (click)="navToLogout()" [outlined]="true">
                    <div class="flex gap-3">
                        <span class="align-content-center bg-red-500 border-round-xl w-3rem h-3rem text-white">
                            <i class="pi pi-sign-out"></i>
                        </span>
                        <div class="align-content-center text-gray-700">ออกจากระบบ</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</p-sidebar>